import {LOCALES} from '../locales';

export default {
    [LOCALES.ITALIAN]: {
        'zgjidh': 'Scegli il servizio di cui hai bisogno',
        'webservice' : 'Website',
        'appservice': 'Applicazione Mobile',
        'serviceother': 'Servizi',
        'pytja1':'Qual è la tipologia della tua attività?',
        'alternativa1pytja1':'Informativo',
        'alternativa2pytja1':'E-commerce',
        'alternativa3pytja1':'Booking',
        'alternativa4pytja1':'Portali',
        'alternativa5pytja1':'Consegna',
        'alternativa6pytja1':'Riferimento web',
        'pytj1a':'Quanti prodotti conterrà il web?',
        'pytj1b':'Chi si occuperà dello smaltimento dei prodotti?',
        'alternativa1pytj1b':'La terza parte',
        'pytj1c':'Qual è la piattaforma su cui verrà costruito il web?',
        'pytj1d':'Quali saranno i metodi di pagamento sul web?',
        'pytja2':'Requisiti di progettazione WEB',
        'alternativa1pytja2': 'Semplice',
        'alternativa2pytja2':'Avanzato',
        'alternativa3pytja2':'Complesso',
        'pytja3': 'Quante lingue avrà il tuo sito web?',
        'alternativa1pytja3': 'Una lingua',
        'alternativa2pytja3': 'Tanti lingua',
        'pytja4': 'Da quale parte verranno lanciati i materiali?',
        'alternativa1pytja4': 'Cliente',
        'pytja5': 'Quante pagine principali ha il web?',
        'pytja6': 'Hai un host e un dominio?',
        'alternativa1pytja6': 'Non ho niente',
        'alternativa2pytja6': 'Ho Host',
        'alternativa3pytja6': 'Ho Domain',
        'alternativa4pytja6': 'Ho Host e Dominio',
        'pytja7': 'Quanto è importante il posizionamento sul Web nei motori di ricerca?',
        'alternativa1pytja7': 'Per niente importante',
        'alternativa2pytja7': 'Un po importante',
        'alternativa3pytja7': 'Importante',
        'alternativa4pytja7': 'Molto importante',
        'pytja8': 'Sul web ci saranno elementi come:',
        'alternativa1pytja8':'Articoli',
        'alternativa2pytja8':`Domande frequenti`,
        'alternativa3pytja8':'Chat dal vivo',
        'alternativa4pytja8':'Profilo Utente',
        'alternativa5pytja8':'Prenotazioni / Calendario eventi',
        'domarketing':'Vuoi fare marketing?',
        'pytja9':'La tua azienda ha bisogno:',
        'alternativa1pytja9':'Nome',
        'alternativa2pytja9' :'Immagine di marca',
        'alternativa3pytja9':'Tutti e tre',
        'pytja10':'Vuoi la gestione dei social media?',
        'pytja10a':'Qual è la frequenza dei post sui media durante la settimana?',
        'pytja11':'Hai bisogno di un set fotografico?',
        'pytja11a':'Quante volte al mese?',
        'alternativa1pytja11a':'1 volta al mese',
        'alternativa2pytja11a':'2 volta al mese',
        'pytja12':'Vuoi una campagna di marketing?',
        'pytja12a':'Dove vuoi essere promosso? ',
        'alternativa1pytja12a':'Ovunque',
        'pytja13':'Vuoi registrare legalmente il marchio?',
        'titulliformes':'Compila i campi inviandoci automaticamente i dettagli della richiesta',
        'dowebsite':'Vuoi fare website?',
        'personalizo':'Personalizzare',
        'dergo':'Invia',
        'emri': 'Nome',
        'phone':'Cellulare',
        'link':'Sito Web',
        'kerkesa':'Nuova richiesta',
        'rinovim':'Rinovare',
        'brandiri':'Nuova',
        'doBrandTeRi':'Vorresti un rinnovamento del marchio o un nuovo marchio?',
        'appTitle':`Specificare in dettaglio i requisiti e le funzionalità dell'applicazione`,
        'alternativa':'puoi scegliere piu di una opsione',
        'faqet':'Prima pagina, Chi siamo, Servizi, Galleria, Contatti',
    }
}
